export const SCRIPT_CATEGORIES = [
  { value: 'all', label: 'All' },
  { value: 'opener', label: 'Openers' },
  { value: 'objection', label: 'Objections' },
  { value: 'close', label: 'Closes' },
  { value: 'follow_up', label: 'Follow-Ups' },
  { value: 'custom', label: 'Custom' },
] as const;

export const PRODUCT_TYPES = [
  { value: 'fex', label: 'Final Expense' },
  { value: 'aged_fex', label: 'Aged Final Expense' },
  { value: 'term_life', label: 'Term Life' },
  { value: 'whole_life', label: 'Whole Life' },
  { value: 'iul', label: 'IUL' },
  { value: 'mortgage_protection', label: 'Mortgage Protection' },
  { value: 'annuity', label: 'Annuity' },
] as const;

export type ScriptCategory = (typeof SCRIPT_CATEGORIES)[number]['value'];
export type ProductType = (typeof PRODUCT_TYPES)[number]['value'];
